import React from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { Lock } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';

const LoginPromptDialog = ({ isOpen, onClose, featureName = 'this feature' }) => {
    const { login } = useAuth();

    const handleLoginSuccess = async (credentialResponse) => {
        try {
            await login(credentialResponse.credential);
            onClose();
        } catch (err) {
            console.error('Login failed:', err);
        }
    };

    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className="bg-[#0f172a] border-[#1e293b] text-[#f8fafc] max-w-sm">
                <DialogHeader>
                    <DialogTitle className="flex items-center gap-2 text-[#f8fafc]">
                        <Lock className="w-5 h-5 text-[#d4af37]" />
                        Sign in Required
                    </DialogTitle>
                </DialogHeader>

                <div className="space-y-4 py-2">
                    <p className="text-sm text-[#94a3b8]">
                        Create an account or sign in to use <strong className="text-[#f8fafc]">{featureName}</strong>.
                    </p>
                    <p className="text-xs text-[#475569]">
                        Your data (custom meanings, translations, and AI rules) will be saved to your account and kept private.
                    </p>

                    <div className="flex justify-center pt-2">
                        <GoogleLogin
                            onSuccess={handleLoginSuccess}
                            onError={() => console.error('Google Login Failed')}
                            size="large"
                            theme="filled_black"
                            text="continue_with"
                            shape="pill"
                            width="280"
                        />
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default LoginPromptDialog;
